module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600-0e2e74067749876000ce112eaa2fbdef.jpg";